export const ROOT_API = 'https://api.laguna-sun.ru';